import React from "react";
import AdminLayout from "@/components/AdminLayout";
import CmsResource from "@/components/CmsResource";

const fields = [
  { name: "name", label: "Nome", type: "text" },
  { name: "client_type", label: "Tipo de cliente", type: "select", options: ["comprador", "vendedor"] },
  { name: "zone", label: "Zona", type: "text" },
  { name: "rating", label: "Estrelas (1–5)", type: "number" },
  { name: "photo", label: "Foto", type: "image", wide: true },
  { name: "video_url", label: "Vídeo depoimento (YouTube/Vimeo)", type: "text", wide: true, placeholder: "https://..." },
  { name: "testimonial", label: "Testemunho", type: "textarea", wide: true, rows: 4 },
];

const defaults = { name: "", client_type: "comprador", zone: "", rating: 5, photo: "", video_url: "", testimonial: "" };

export default function AdminTestimonials() {
  return (
    <AdminLayout>
      <CmsResource
        resource="testimonials"
        title="Testemunhos"
        singular="Testemunho"
        fields={fields}
        defaults={defaults}
        displayColumns={[
          { key: "name", label: "Nome" },
          { key: "client_type", label: "Tipo" },
          { key: "zone", label: "Zona" },
          { key: "rating", label: "Estrelas" },
        ]}
      />
    </AdminLayout>
  );
}
